import React from "react";
import * as S from "./styled";
import CheckmarkIcon from "_c/icon/Checkmark";
import { usePremiumFeaturesList } from "./hooks/usePremiumFeaturesList";
import { listVariants, itemVariants } from "./motion";
import type { TFunction } from "i18next";

type tProps = {
  role?: "saloon";
  t: TFunction;
};
const Features = ({ t, role }: tProps) => {
  const features = usePremiumFeaturesList({ isSaloon: role === "saloon" });
  return (
    <S.Features>
      <h2>{t("premium:title")}</h2>
      <S.FeaturesList variants={listVariants} initial="hidden" animate="show">
        {features.map((feat, idx) => (
          <S.Feature variants={itemVariants} key={idx}>
            <div>
              <CheckmarkIcon width="10" color="var(--color-primary)" />
            </div>
            <span>{feat}</span>
          </S.Feature>
        ))}
      </S.FeaturesList>
    </S.Features>
  );
};

export default Features;
